module.exports = __webpack_public_path__ + "img/10_Distal-T.067aec1b.png";